import { render, staticRenderFns } from "./AddOtherForm.vue?vue&type=template&id=39db3e25&scoped=true&"
import script from "./AddOtherForm.vue?vue&type=script&lang=js&"
export * from "./AddOtherForm.vue?vue&type=script&lang=js&"
import style0 from "./AddOtherForm.vue?vue&type=style&index=0&id=39db3e25&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39db3e25",
  null
  
)

export default component.exports